import { FormItem } from '../../../store/context/formContext';

export const formItems = {
    monthlyCost: 'monthlyCost',
    mortgageType: 'mortgageType',
    period: 'period',
    interest: 'interest',
    isNhg: 'isNhg',
};

export const getPostData = (values: FormItem) => {
    let postData: { [id: string]: any } = {
        monthlyCost: parseInt(values.monthlyCost),
        mortgageType: parseInt(values.mortgageType),
        interestRate: parseFloat(values.interest),
        fixedInterestPeriod: parseInt(values.period),
        isNhg: values.isNhg === 'true' ? true : false,
    };

    return postData;
};
